/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useMutation } from '@apollo/client';
import { useSessionContext } from '@exo/frontend-common-session-context';

const CART_REMOVE_DISCOUNT_CODES = gql`
  mutation Mutation($cartId: ID!) {
    cartRemoveDiscountCodes(cartId: $cartId) {
      id
      grandTotal {
        value
        currency
      }
      totalProductPrice {
        currency
        value
      }
      totalAdjustment {
        value
        currency
      }
      remainingToPay {
        value
        currency
      }
      adjustments {
        type
        amount {
          value
          currency
        }
        title
      }
    }
  }
`;

const CART_APPLY_DISCOUNT_CODE = gql`
  mutation CartApplyDiscountCode(
    $discountCode: String
    $cartId: ID
    $distributionGroupIds: [ID!]
    $filter: AvFilter
    $shipNodeIds: [ID!]
  ) {
    cartApplyDiscountCode(discountCode: $discountCode, cartId: $cartId) {
      id
      grandTotal {
        value
        currency
      }
      totalProductPrice {
        value
        currency
      }
      totalShippingCharge {
        value
        currency
      }
      adjustments {
        type
        amount {
          value
          currency
        }
        title
      }
      totalAdjustment {
        value
        currency
      }
      totalShippingTax {
        value
        currency
      }
      totalSalesTax {
        value
        currency
      }
      lineItems {
        id
        partnumber
        quantity
        product {
          slug
          name
          availability(
            distributionGroupIds: $distributionGroupIds
            filter: $filter
            shipNodeIds: $shipNodeIds
          ) {
            status
            availableDate
            availableQuantity
            shipNode {
              id
              name
              distance
              alertType
              alertLevel
            }
            distributionGroup {
              id
              name
              alertType
              alertLevel
            }
          }
          description
          longDescription
          thumbnail
          fullImage
          price {
            list {
              value
              currency
            }
            offer {
              value
              currency
            }
          }
          type
          id
          partnumber
          categories {
            typeId
            id
          }
          allAttributes {
            id
            name
            categoryName
            value {
              id
              value
              sequence
            }
          }
        }
        productId
        unitPrice {
          value
          currency
        }
        linePrice {
          value
          currency
        }
        shippingInfo {
          shippingAddress {
            id
            title
            titleCode
            address1
            address2
            city
            company
            country
            countryCode
            countryName
            firstName
            lastName
            name
            phone
            province
            zip
            email
            availableForShipping
            availableForBilling
          }
          pickupInStore {
            id
            identifier
            name
            city
            state
            country
            countryCode
            countryName
            address
            zipCode
            latitude
            longitude
            phone
            openHours
          }
          shipMode {
            id
            identifier
            description
            type
            shippingRate {
              value
              currency
            }
          }
          instruction
        }
        adjustments {
          title
          amount {
            value
            currency
          }
          type
        }
      }
    }
  }
`;

export const usePromoCode = () => {
  const sessionContext = useSessionContext();

  const variables = {
    cartId: sessionContext.cartId,
    // discountCode,
    // To force refresh at login/logout
    __token: `${sessionContext.token} ${sessionContext.cartId}`
  };

  const [
    applyPromoCode,
    { loading: applyCodeLoading, data: applyCodeData, error: applyCodeError }
  ] = useMutation(CART_APPLY_DISCOUNT_CODE, {
    // eslint-disable-next-line no-console
    onError: e => console.log('applyPromoCode Error!', e)
  });

  const [
    remomvePromoCode,
    { loading: removeCodeLoading, data: removeCodeData, error: removeCodeError }
  ] = useMutation(CART_REMOVE_DISCOUNT_CODES, {
    // eslint-disable-next-line no-console
    onError: e => console.log('remomvePromoCode Error!', e)
  });

  return {
    applyCode: async (discountCode: string) => {
      const vars = { ...variables, discountCode };
      return applyPromoCode({ variables: vars });
    },
    applyCodeData,
    applyCodeLoading,
    applyCodeError,
    removeCode: async () => {
      return remomvePromoCode({ variables });
    },
    removeCodeData,
    removeCodeLoading,
    removeCodeError
  };
};
